import { apiChargeForte } from "../../services/paymentService";

/**
 * Forte provider: client tokenization + server-side charge.
 */
export const createToken = (forteJs, paymentData) =>
  new Promise((resolve, reject) => {
    forteJs
      .createToken(paymentData)
      .success((res) => {
        if (res?.event === "success") {
          resolve(res.onetime_token);
        } else {
          reject(new Error(res?.error || "Tokenization failed"));
        }
      })
      .error((err) => reject(new Error(err?.message || "Token API error")));
  });

/**
 * Calls backend to perform Forte transaction using the one-time token.
 * The backend must validate amounts and compute service fees server-side.
 */
export const chargeServer = async ({
  domain,
  registration_id,
  merchant,
  authorization_amount,
  service_fee_amount,
  billing_address,
  card_type,
  token,
}) => {
  return await apiChargeForte({
    domain,
    registration_id,
    merchant,
    authorization_amount,
    service_fee_amount,
    billing_address,
    card_type,
    token,
  });
};

export default {
  createToken,
  chargeServer,
};
